export default "__VITE_ASSET__DIJ3d3d8__"